import React from "react";
import styled from "styled-components";

const Styles = styled.div`
  .snt-sidebar-group {
    margin-bottom: 16px;
  }

  .snt-sidebar-group-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .snt-sidebar-group-header .snt-sidebar-group-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .snt-sidebar-group-header .snt-sidebar-group-icon svg {
    width: 24px;
    height: 24px;
  }

  .snt-sidebar-group-header h5 {
    margin-bottom: 0;
    margin-left: 8px;
    font-weight: normal;
  }

  hr.snt-sidebar-group-divider {
    border: none;
    border-top: 1px solid #e7e7e2;
    margin: 16px 0;
    opacity: 1;
    height: 0;
  }
`;

interface RightSidebarGroupProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  count?: number;
  showDivider?: boolean;
  children: React.ReactNode;
}

const RightSidebarGroup: React.FC<RightSidebarGroupProps> = ({
  icon,
  title,
  count,
  showDivider = false,
  children,
}) => {
  return (
    <Styles>
      {showDivider && <hr className="snt-sidebar-group-divider" />}
      <div className="snt-sidebar-group">
        <div className="snt-sidebar-group-header">
          <div className="snt-sidebar-group-icon">{icon}</div>
          <h5>
            {title}
            {count !== undefined && ` (${count})`}
          </h5>
        </div>
        <div className="snt-sidebar-group-content">{children}</div>
      </div>
    </Styles>
  );
};

export default RightSidebarGroup;
